var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8039)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8039",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 49.0232C23.3736 49.0235 21.7516 48.8599 20.1583 48.5349C17.0854 47.9056 14.1665 46.6773 11.5681 44.9202C7.70571 42.3129 4.6823 38.6414 2.86423 34.3506C2.25 32.8973 1.78118 31.3868 1.46462 29.8411C0.813877 26.6462 0.813877 23.3529 1.46462 20.1581C2.09396 17.0852 3.32224 14.1663 5.07936 11.5679C7.68664 7.70563 11.358 4.6823 15.6487 2.86423C17.1019 2.25001 18.6124 1.78119 20.1581 1.46462C23.3529 0.813877 26.6462 0.813877 29.8411 1.46462C32.914 2.09396 35.8329 3.32224 38.4312 5.07936C42.2936 7.68668 45.3169 11.3581 47.1349 15.6489C47.7493 17.1021 48.2182 18.6125 48.5349 20.1581C49.1857 23.3529 49.1857 26.6462 48.5349 29.8411C47.9056 32.914 46.6773 35.8329 44.9202 38.4312C42.3129 42.2936 38.6414 45.3169 34.3507 47.1349C32.8974 47.7493 31.3868 48.2183 29.8411 48.5349C28.2478 48.8599 26.6259 49.0235 24.9998 49.0232ZM25.075 32.0408C23.9392 32.0408 23.1454 32.7812 23.1445 33.8413C23.1445 33.8678 23.1445 33.8924 23.1452 33.9163C23.1452 35.0271 23.9097 35.8029 25.0045 35.8029C25.254 35.81 25.5024 35.7661 25.7345 35.674C25.9665 35.5818 26.1773 35.4433 26.354 35.2669C26.5306 35.0904 26.6695 34.8798 26.762 34.6479C26.8545 34.416 26.8987 34.1677 26.892 33.9181C26.892 33.9117 26.892 33.9053 26.892 33.8986C26.8919 32.8391 26.1107 32.0401 25.0748 32.0401L25.075 32.0408ZM23.5001 14.8647V28.8882L26.5144 28.9867V14.8478H23.5003V14.8648L23.5001 14.8647Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStatus);
export default __webpack_public_path__ + "static/media/add_status.648442bf891f715ba65a383703db3f0e.svg";
export { ForwardRef as ReactComponent };